var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99949 13.224C9.90337 13.224 9.81379 13.2069 9.73074 13.1727C9.64768 13.1385 9.5706 13.0846 9.49949 13.0108L5.80469 9.31625C5.68942 9.20347 5.63212 9.0675 5.63282 8.90833C5.63365 8.74917 5.6931 8.61271 5.81115 8.49896C5.92921 8.38507 6.06546 8.32812 6.2199 8.32812C6.37421 8.32812 6.50824 8.38507 6.62199 8.49896L9.99949 11.8762L13.377 8.49896C13.4853 8.39049 13.618 8.33493 13.7751 8.33229C13.9322 8.32951 14.0698 8.38507 14.1878 8.49896C14.3059 8.61271 14.3666 8.74785 14.3701 8.90437C14.3736 9.0609 14.3163 9.19819 14.1982 9.31625L10.5034 13.0108C10.4297 13.0846 10.3513 13.1385 10.2682 13.1727C10.1852 13.2069 10.0956 13.224 9.99949 13.224Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.39f8444d.svg";
export { ForwardRef as ReactComponent };